import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from 'libs/router';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { t } from 'utils/language';
import { getLocationUrl, getLocationWithExtendedQuery } from 'utils/client';
import { CONTENT_APPROVAL_SORT_KEYS, CONTENT_APPROVAL_SORT_OPTIONS } from 'utils/contentApproval';

import type { LocationWindow, SelectOption } from 'types';

type OwnProps = {
  sortOptions?: Array<SelectOption>,
  currentSort: string,
  onSort: (a: string) => void
};

type StateProps = {
  location: LocationWindow
};

type Props = OwnProps & StateProps;

const ContentApprovalSort = (
  {
    location,
    sortOptions,
    currentSort,
    onSort
  }: Props
): JSX.Element => {
  const options = sortOptions || CONTENT_APPROVAL_SORT_OPTIONS;
  const sort = currentSort || CONTENT_APPROVAL_SORT_KEYS[0];

  const handleSort = (value: string): void => {
    const extendedQueryLocation = getLocationWithExtendedQuery(location, { sort: value });
    const locationUrl = getLocationUrl(extendedQueryLocation);

    navigate.to(locationUrl);

    onSort(value);
  };

  return (
    <div className="content-approval-sort">
      <div className="content-approval-sort__label">
        {t('content_approval.sort.label')}:
      </div>
      <MixedSelectDropdown
        items={
          options.map(sortValue => ({
            identifier: sortValue.value,
            isDisabled: false,
            isSelected: sort === sortValue.value,
            value: sortValue.value,
            label: sortValue.label
          }))
        }
        name="content-approval-sort"
        onItemsToggle={(updatedItems, data, selectedItem) => {
          const sortValue = selectedItem?.value;
          handleSort(sortValue || options[0].value);
        }}
        className="content-approval-sort__select"
      />
    </div>
  );
};

const mapStateToProps = ({ router }): StateProps => ({
  location: router.location
});

export default connect(mapStateToProps)(ContentApprovalSort);
